export const normalizeHour = (hh) => {
    let res = 0
    res = Number(hh.substring(0, hh.lastIndexOf(":"))) * 60
    res += Number(hh.substring(hh.lastIndexOf(":") + 1, hh.length))
    return res
}